export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-hearing-aid-6c5e478010e8cce31adf2083ab40ba56.svg";